// Recursively prefix route names so a page's /web/, /mob/ and /mobile/ variants get distinct
// route names (Web_BalancePage) while sharing one route definition.
export function prefixRouteNames(routes, prefix = '') {
  if (!prefix) {
    return routes;
  }

  // Some nested routes are already prefixed by generateChildrenRoutes (via addPrefix, or by an
  // inner prefixRouteNames call on their children) before the outer pass reaches them, so
  // prefixing has to be idempotent — otherwise they come out as Web_Web_Foo.
  const nameWithPrefix = name => (name.startsWith(`${prefix}_`) ? name : `${prefix}_${name}`);

  return routes.map(route => {
    const newRoute = { ...route };

    if (newRoute.name) {
      newRoute.name = nameWithPrefix(newRoute.name);
    }

    // For web routes, remove leading slash from child paths to make them relative
    // we use /web/ as parent, this is ok for nested children without leading slash such as 'sr'
    // but not good for nested children with a leading slash such as '/ob'
    // we dont want to refactor all the routes themselves so we handle it here only
    if (['Web', 'Mob', 'Mobile'].includes(prefix) && newRoute.path && newRoute.path.startsWith('/')) {
      newRoute.path = newRoute.path.substring(1);
    }

    if (newRoute.children) {
      newRoute.children = prefixRouteNames(newRoute.children, prefix);
    }

    return newRoute;
  });
}

export default prefixRouteNames;
